import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { htmlDecode } from 'src/helpers/strings';
@Component({
  selector: 'mb-wb-multi-select',
  templateUrl: './wb-multi-select.component.html',
  styleUrls: ['./wb-multi-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WbMultiSelectComponent {
  @Input() label!: string;
  @Input() checkboxCount: number = 0;
  @Output() resetTagMenuEvent = new EventEmitter<void>();

  public open: boolean = false;

  public onResetClick() {
    this.resetTagMenuEvent.emit();
    return;
  }

  public toggleOverlay() {
    this.open = this.open ? false : true;
  }
  public get decodedLabel(): string | null {
    if (!this.label) return null;
    return htmlDecode(this.label);
  }
}
